import PropTypes from 'prop-types'
import { Fragment } from 'react'
import LicenseLineItem from './LicenseLineItem'

const generateAddonItem = (addons) => {
  let addonVal = ''
  if (addons) {
    addonVal = addons.map((each, idx) => {
      const { ui_display_name } = each
      return <Fragment key={idx}>
        {ui_display_name}{idx === addons.length - 1 ? '' : ', '}
      </Fragment>
    })
  }
  return <>
    <LicenseLineItem
      color='green'
      label={'Add-ons Available: '}
      value={addonVal ?? 'None'}
    />
  </>
}

const LicenseAddon = ({ addons }) => {
  return <Fragment>
    {generateAddonItem(addons)}
  </Fragment>

}

LicenseAddon.propTypes = {
  addons: PropTypes.array,
}

export default LicenseAddon
